import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import styles from "./UserProfileDropDown.module.scss";
import NoImageSVG from "../SVGComponents/NoImageSVG";
import { serverFiles } from "../../utils/utils";
// import Tooltip from "components/common/Tooltip/Tooltip";
import { useDispatch, useSelector } from "react-redux";
import Drawer from "components/Drawer/Drawer";
import NO_IMAGE from "../../images/NO_IMAGE.jpg";
import { getUserProfile } from "reducer/profileSlice";
import TermsConditions from "components/termsConditions/TermsConditions";
import CommunityGuideline from "components/CommunityGuidelines/CommunityGuideline";
import Modal from "components/Modal/Modal";

const UserProfileDropDown = ({
  userProfile,
  setBusinessModal,
  setShowDropdown,
  showDropDown,
}) => {
  const { activePlan } = useSelector((state) => state.payment);
  const [termsModal, setTermsModal] = useState(false);
  const [guideLineModal, setGuideLineModal] = useState(false);

  const handleLogout = () => {
    localStorage.clear();
    window.location.reload();
  };

  const dispatch = useDispatch();

  // useEffect(() => {
  //   dispatch(getUserProfile());
  // }, []);

  return (
    <>
      <div
        className={styles.dropdown_overlay}
        onClick={() => setShowDropdown(false)}
      ></div>
      <div className={styles.user_profile_dropdown}>
        <section className={styles.dropdown_top_profile}>
          {userProfile?.profileUrl || userProfile?.companyResponseDto?.logo ? (
            <Link to={"/user-profile"}>
              <img
                src={serverFiles(
                  userProfile?.profileUrl ||
                    userProfile?.companyResponseDto?.logo
                )}
                height={40}
                width={40}
                alt=""
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = NO_IMAGE;
                }}
              />
            </Link>
          ) : (
            <NoImageSVG />
          )}

          <div className={styles.dropdown_top_details}>
            <p className={styles.dropdown_username}>
              {userProfile?.firstName || userProfile?.companyResponseDto?.name}{" "}
              {userProfile?.lastName}
            </p>
            {/* <p className={styles.dropdown_designation}>
              <Tooltip
                force={true}
                place="bottom"
                data={
                  userProfile?.industry?.join(", ") ||
                  userProfile?.companyResponseDto?.industry?.join(", ")
                }
              >
                {userProfile?.industry[0] ||
                  userProfile?.companyResponseDto?.industry[0]}
              </Tooltip>
            </p> */}
          </div>
        </section>
        <section
          className={styles.dropdown_links_center}
          onClick={() => setShowDropdown(false)}
        >
          {userProfile?.userType === "CREATOR" ? (
            <>
              <Link className={styles.dropdown_link_center} to="/user-profile">
                My Profile
              </Link>
              <Link
                className={styles.dropdown_link_center}
                to="/my-applications"
              >
                My Applications
              </Link>
              {/* <Link
                className={styles.dropdown_link_center}
                to="/saved-projects"
              >
                Saved Projects
              </Link> */}

              <Link
                className={styles.dropdown_link_center}
                to="/profile-creation"
              >
                Edit Profile
              </Link>
              {/* <Link
                className={styles.dropdown_link_center}
                to="/edit-preference"
              >
                Edit Preference
              </Link> */}
            </>
          ) : (
            <>
              {/* <Link className={styles.dropdown_link_center} to="/feed">
                Post & Activity
              </Link> */}
              <Link className={styles.dropdown_link_center} to="/user-profile">
                My Profile
              </Link>
              {/* <Link
                className={styles.dropdown_link_center}
                to={
                  activePlan?.status === "ACTIVE"
                    ? "/payment-success?success=true&receipt=true"
                    : activePlan?.freeTrial
                    ? "/payment-success?success=false"
                    : "/payment-plan"
                }
              >
                My Subscriptions
              </Link> */}
              {/* <Link
                className={styles.dropdown_link_center}
                to={"/projects/create-project"}
              >
                Create A Project
              </Link> */}

              {/* <Link
                className={styles.dropdown_link_center}
                to="/profile-creation"
              >
                Edit Profile
              </Link> */}

              <p
                onClick={() => {
                  setBusinessModal((prev) => !prev);
                  // setShowDropdown((prev) => !prev);
                }}
                className={styles.dropdown_link_center}
              >
                Edit Profile
              </p>

              {/* <Link
                className={styles.dropdown_link_center}
                to="/edit-preference"
              >
                Edit Preference
              </Link> */}
            </>
          )}
        </section>
        <section className={styles.dropdown_links_bottom}>
          {/* <Link to="/forgot-password" className={styles.dropdown_link_bottom}>
            Change Password
          </Link> */}
          {/* <Link to="/change-email" className={styles.dropdown_link_bottom}>
            Change Email Password
          </Link>
          <Link to="/delete-account" className={styles.dropdown_link_bottom}>
            Delete My Account
          </Link> */}
          <p onClick={handleLogout} className={styles.dropdown_logout_button}>
            Logout
          </p>
        </section>
      </div>
      <Drawer
        shadowClassName={styles.mobile_drawer}
        bodyClassName={styles.mobile_drawer_body}
        drawerOpen={showDropDown}
        onClose={() => setShowDropdown(false)}
        width="271px"
        height="100vh"
        position="left"
      >
        <section className={styles.dropdown_top_profile}>
          {userProfile?.profileUrl || userProfile?.companyResponseDto?.logo ? (
            <Link to={"/user-profile"}>
              <img
                src={serverFiles(
                  userProfile?.profileUrl ||
                    userProfile?.companyResponseDto?.logo
                )}
                height={40}
                width={40}
                alt=""
              />
            </Link>
          ) : (
            <NoImageSVG />
          )}

          <div className={styles.dropdown_top_details}>
            <p className={styles.dropdown_username}>
              {userProfile?.firstName || userProfile?.companyResponseDto?.name}{" "}
              {userProfile?.lastName}
            </p>
          </div>
        </section>
        <section
          className={styles.dropdown_links_center}
          onClick={() => setShowDropdown(false)}
        >
          {userProfile?.userType === "CREATOR" ? (
            <>
              <Link className={styles.dropdown_link_center} to="/user-profile">
                My Profile
              </Link>
              <Link
                className={styles.dropdown_link_center}
                to="/my-applications"
              >
                My Applications
              </Link>

              <Link
                className={styles.dropdown_link_center}
                to="/profile-creation"
              >
                Edit Profile
              </Link>
            </>
          ) : (
            <>
              <Link className={styles.dropdown_link_center} to="/user-profile">
                My Profile
              </Link>
              <Link
                className={styles.dropdown_link_center}
                to={
                  !activePlan?.freeTrial
                    ? "/payment-success?success=true"
                    : "/payment-plan"
                }
              >
                My Subscriptions
              </Link>
              {/* <Link
                className={styles.dropdown_link_center}
                to={"/projects/create-project"}
              >
                Create A Project
              </Link> */}
              <p
                onClick={() => {
                  setBusinessModal((prev) => !prev);
                }}
                className={styles.dropdown_link_center}
              >
                Edit Profile
              </p>
            </>
          )}

          <Link className={styles.dropdown_link_center} to="/about-us">
            About Us
          </Link>
          <Link className={styles.dropdown_link_center} to="/contact-us">
            Contact Us
          </Link>
          <p
            onClick={(e) => {
              e.stopPropagation();
              setTermsModal((prev) => !prev)
            }}
          >
            Terms & Privacy Policy
          </p>
          <p
            onClick={(e) => {
              e.stopPropagation();
              setGuideLineModal((prev) => !prev)}}
          >
            Community guidelines
          </p>
        </section>
        <div className={styles.horizontal_seperator}></div>
        <section className={styles.dropdown_links_bottom}>
          {/* <Link to="/forgot-password" className={styles.dropdown_link_bottom}>
            Change Password
          </Link> */}
        </section>
        <div className={styles.horizontal_seperator}></div>
        <section className={styles.dropdown_links_bottom}>
          <p onClick={handleLogout} className={styles.dropdown_logout_button}>
            Logout
          </p>
        </section>
        <Modal
          // width="40rem"
          onClose={(e) => {
            // e.stopPropagation()
            setGuideLineModal(false);
          }}
          heading="Community guidelines"
          modalOpen={guideLineModal}
          showCrossIcon={true}
        >
          <CommunityGuideline />
        </Modal>
        <Modal
          // width="40rem"
          onClose={(e) => {
            // e.stopPropagation()
            setTermsModal(false);
          }}
          heading="Terms & Conditions"
          modalOpen={termsModal}
          showCrossIcon={true}
        >
          <TermsConditions />
        </Modal>
      </Drawer>
    </>
  );
};

export default UserProfileDropDown;
